import { Injectable } from '@angular/core';
import { enumTransportationMode } from '@data-layer/enums/entry-summaries';

@Injectable({ providedIn: 'root' })
export class EsLabelsService {
  private readonly labelsData: any = {
    [enumTransportationMode.OCEAN]: {
      titleMaster: 'FORM_LABEL.MASTER_BILL_OF_LADING',
      titleHouse: 'FORM_LABEL.HOUSE_BILL_OF_LADING',
      titleCarrier: 'LABELS.CARRIER',
      titleNumber: 'LABELS.BL_NUMBER',
    },
    [enumTransportationMode.AIR]: {
      titleMaster: 'FORM_LABEL.MASTER_AIRWAY_BILL',
      titleHouse: 'FORM_LABEL.HOUSE_AIRWAY_BILL',
      titleCarrier: 'FORM_LABEL.PREFIX',
      titleNumber: 'LABELS.BL_NUMBER',
    },
    [enumTransportationMode.RAIL]: {
      titleMaster: 'FORM_LABEL.MASTER_BILL_OF_LADING',
      titleHouse: 'FORM_LABEL.HOUSE_BILL_OF_LADING',
      titleCarrier: 'LABELS.CARRIER',
      titleNumber: 'LABELS.BL_NUMBER',
    },
    [enumTransportationMode.TRUCK]: {
      titleMaster: 'FORM_LABEL.MASTER_CARRIER',
      titleHouse: 'FORM_LABEL.HOUSE_BILL_OF_LADING',
      titleCarrier: 'LABELS.CARRIER',
      titleNumber: 'FORM_LABEL.MASTER_BL',
    },
    default: {
      titleMaster: 'FORM_LABEL.MASTER_BILL_OF_LADING',
      titleHouse: 'FORM_LABEL.HOUSE_BILL_OF_LADING',
      titleCarrier: 'LABELS.CARRIER',
      titleNumber: 'LABELS.BL_NUMBER',
    },
  };

  constructor() {}

  public getLabelsData(transportationMode: enumTransportationMode = enumTransportationMode.OCEAN): {
    titleMaster: string;
    titleHouse: string;
    titleCarrier: string;
    titleNumber: string;
  } {
    return this.labelsData[transportationMode || enumTransportationMode.OCEAN] || this.labelsData.default;
  }

  public getHeaderIconName(transportationMode: enumTransportationMode): string {
    let headerIconName: string = null;
    switch (transportationMode) {
      case enumTransportationMode.AIR:
        headerIconName = 'ic_plain';
        break;
      case enumTransportationMode.OCEAN:
        headerIconName = 'vessel';
        break;
      case enumTransportationMode.RAIL:
        headerIconName = 'rail';
        break;
      case enumTransportationMode.TRUCK:
        headerIconName = 'icon_truck';
        break;
      default:
        break;
    }

    return headerIconName;
  }
}
